import AllCategoriesContainer from './AllCategoriesContainer.jsx';

export {AllCategoriesContainer}



// WEBPACK FOOTER //
// ./components/all-categories/index.js